import React from 'react'
import { Button } from 'primereact/button'
import { ContactTypeIds } from 'modules/Constants'

const ModalFooter = ({
    onCancel,
    onConfirm,
    selectedContact,
    selectedName,
    selectedMembership
}) => {
    const canAddAsContributor = () => {
        if (!selectedContact || !selectedName) return false
        
        const contactTypeId = selectedContact.contactTypeId
        
        // For Member contact type (1), they MUST have a selectable membership
        if (contactTypeId === ContactTypeIds.Member) {
            return selectedMembership != null
        }
        
        // All other contact types (Potential Member, Estate, Non-Eligible, Company, etc.)
        // can be added without a membership requirement
        return true
    }

    const canConfirm = canAddAsContributor()

    return (
        <div className="app-footer justify-content-end gap-2">
            <Button
                label="Confirm contributor"
                icon="fa-light fa-check"
                className="green mr-2"
                raised
                onClick={onConfirm}
                disabled={!canConfirm}
            />
            <Button
                label="Cancel"
                icon="fa-light fa-xmark"
                className="yellow mr-3"
                raised
                onClick={onCancel}
            />
        </div>
    )
}

export default ModalFooter
